/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Also_CreateInputs */

const en_task_flow_also_create = /** @type {(inputs: Task_Flow_Also_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Also create`)
};

const pt_br2_task_flow_also_create = /** @type {(inputs: Task_Flow_Also_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Também criar`)
};

/**
* | output |
* | --- |
* | "Also create" |
*
* @param {Task_Flow_Also_CreateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_also_create = /** @type {((inputs?: Task_Flow_Also_CreateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Also_CreateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_also_create(inputs)
	return pt_br2_task_flow_also_create(inputs)
});